export default {
  // 获取当前用户可以使用的流程申请
  list: 'backend.odc.flow.flowJob.add.type.list',

  // 查询工单模板
  formPageGet: 'backend.odc.flow.formPage.get',

  // 查看流程定义
  defineGet: 'backend.odc.flow.define.get',

  // 创建工单
  flowJobAdd: 'backend.odc.flow.flowJob.add',

  // 分页获取个人发起的工单列表
  pageList: 'backend.odc.flow.flowJob.page.list',

  // 查看工单详情
  flowJobGet: 'backend.odc.flow.flowJob.get',

  // 审批工单
  flowJobAudit: 'backend.odc.flow.flowJob.audit'
}
